export default __webpack_public_path__ + "static/media/danceofdeath.154a2432.png";